var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatIlustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.509 51.7933C301.509 51.7933 269.048 21.4269 221.893 30.5567C174.738 39.6865 151.676 76.6125 122.694 101.068C107.524 113.876 86.651 117.511 69.2048 126.969C13.4221 157.188 13.4654 233.957 50.9366 265.552C83.3712 292.907 126.779 298.584 185.469 284.218C244.16 269.853 285.94 261.718 326.527 211.578C367.113 161.437 341.152 92.7087 301.509 51.7933Z",
    fill: "url(#paint0_linear_575_72001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M301.509 51.7933C301.509 51.7933 269.048 21.4269 221.893 30.5567C174.738 39.6865 151.676 76.6125 122.694 101.068C107.524 113.876 86.651 117.511 69.2048 126.969C13.4221 157.188 13.4654 233.957 50.9366 265.552C83.3712 292.907 126.779 298.584 185.469 284.218C244.16 269.853 285.94 261.718 326.527 211.578C367.113 161.437 341.152 92.7087 301.509 51.7933Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.133 128.761C313.676 126.329 311.642 128.362 310.024 126.329C308.406 124.295 314.481 119.034 302.313 113.755C302.313 113.755 301.509 102.401 284.876 101.994C268.243 101.588 272.709 113.365 268.269 116.195C263.83 119.025 262.584 114.568 258.127 117.407C253.67 120.245 255.695 125.922 252.069 126.736C248.443 127.549 243.554 123.084 239.088 125.922C234.623 128.761 234.632 131.201 232.598 131.201C230.564 131.201 226.54 129.574 224.083 131.201C221.625 132.828 218.812 134.844 218.812 134.844H321.378C321.378 134.844 322.598 131.201 318.133 128.761Z",
    stroke: "url(#paint1_linear_575_72001)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.299 250.788C244.09 246.851 240.811 250.131 238.197 246.851C235.584 243.571 245.397 235.056 225.744 226.54C225.744 226.54 224.429 208.194 197.567 207.502C170.706 206.81 177.906 225.848 170.697 230.435C163.489 235.021 161.524 227.838 154.324 232.408C147.124 236.977 150.387 246.202 144.519 247.5C138.652 248.798 130.76 241.607 123.551 246.193C116.342 250.78 116.342 254.709 113.063 254.709C109.783 254.709 103.232 252.112 99.303 254.709C95.3741 257.305 90.7876 260.611 90.7876 260.611H256.543C256.543 260.611 258.508 254.717 251.299 250.788Z",
    stroke: "url(#paint2_linear_575_72001)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5491 174.505C89.0827 173.155 87.9577 174.28 87.0577 173.155C86.1577 172.03 89.5241 169.113 82.7914 166.232C82.7914 166.232 82.3414 159.94 73.1337 159.715C63.926 159.49 66.401 166.007 63.9346 167.573C61.4683 169.139 60.7846 166.708 58.3183 168.248C55.852 169.788 56.9683 172.964 54.952 173.44C52.9356 173.916 50.2356 171.424 47.7693 172.99C45.3029 174.557 45.2943 175.846 44.1346 175.846C42.975 175.846 40.7683 174.981 39.427 175.846C38.0856 176.712 36.502 177.871 36.502 177.871H93.3145C93.3145 177.871 94.0154 175.846 91.5491 174.505Z",
    stroke: "url(#paint3_linear_575_72001)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.807 306.511C104.807 306.511 111.211 293.287 106.537 284.512C101.864 275.737 96.0057 283.924 87.8192 273.392C79.6326 262.861 79.6327 251.169 72.6057 250.027C65.5788 248.885 61.4942 251.758 56.2327 250.027C50.9711 248.296 57.4009 233.065 46.2807 229.552C35.1605 226.038 28.1076 234.822 20.5442 226.627C12.9807 218.432 1.82592 214.927 1.23746 219.029C0.648996 223.131 10.0125 222.534 13.5259 228.384C17.0394 234.234 27.5625 244.765 27.5625 255.877C27.5625 266.988 37.5057 261.727 44.5326 264.652C51.5596 267.577 50.9625 274.015 51.5509 282.825C52.1394 291.635 67.3442 282.825 69.724 286.918C72.1038 291.012 66.799 292.188 68.5557 301.543C70.3125 310.898 87.5076 311.357 87.5076 311.357",
    fill: "url(#paint4_linear_575_72001)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6606 308.492C93.6606 308.492 81.3461 279.831 63.2423 261.692C45.1384 243.554 32.824 242.386 25.2173 235.956",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7664 254.12L49.8548 251.031L44.0135 237.635",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5076 274.05L72.8133 273.254L71.8441 262.713",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3989 297.762L89.3682 299.475L91.0816 285.049",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2498 215.005C56.2498 215.005 51.5075 215.637 46.4364 203.608C42.2652 193.699 47.9595 185.729 50.1056 183.211C50.1891 183.114 50.2947 183.038 50.4136 182.99C50.5325 182.943 50.6611 182.925 50.7884 182.938C50.9158 182.95 51.0383 182.994 51.1454 183.064C51.2525 183.134 51.3411 183.229 51.4037 183.34C53.0566 186.309 57.946 195.499 58.4739 200.752C59.1056 207.087 56.2498 215.005 56.2498 215.005Z",
    fill: "#59D9C6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.08 256.491C104.08 256.491 101.224 253.964 100.618 248.582C100.013 243.199 104.417 232.745 106.953 234.329C109.489 235.913 110.414 247.63 109.489 251.74C108.563 255.851 104.08 256.491 104.08 256.491Z",
    fill: "#59D9C6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.285 274.863C119.285 274.863 116.429 272.328 115.823 266.945C115.217 261.562 119.622 251.109 122.158 252.692C124.693 254.276 125.619 265.993 124.693 270.112C123.767 274.232 119.285 274.863 119.285 274.863Z",
    fill: "#59D9C6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.272 287.351C127.272 287.351 126.035 283.742 128.137 278.74C130.24 273.738 139.232 266.824 140.66 269.446C142.087 272.068 137.198 282.738 134.308 285.888C131.417 289.038 127.272 287.351 127.272 287.351Z",
    fill: "#59D9C6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.442 269.135C106.442 269.135 103.751 271.835 98.3422 272.172C92.9336 272.51 82.7653 267.49 84.4961 265.05C86.2268 262.61 97.9701 262.315 102.029 263.492C106.087 264.669 106.442 269.135 106.442 269.135Z",
    fill: "#59D9C6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.284 288.805C119.284 288.805 116.593 291.505 111.184 291.834C105.776 292.162 95.6076 287.161 97.3383 284.72C99.0691 282.28 110.812 281.986 114.871 283.162C118.93 284.339 119.284 288.805 119.284 288.805Z",
    fill: "#59D9C6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7557 235.272C84.7557 235.272 81.5884 235.272 79.6932 227.674C77.798 220.076 81.5884 211.837 83.4923 213.421C85.3961 215.005 89.1951 224.827 88.5634 229.578C87.9317 234.329 84.7557 235.272 84.7557 235.272Z",
    fill: "#59D9C6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.072 233.377C65.7402 231.802 65.0145 230.337 63.9626 229.119C62.9108 227.9 61.5673 226.969 60.0576 226.411C54.6662 224.187 44.8528 227.042 44.8528 228.306C44.8528 229.569 48.972 233.377 56.2499 234.961C63.5278 236.544 66.072 233.377 66.072 233.377Z",
    fill: "#59D9C6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.875 253.324C88.875 253.324 88.5635 250.797 82.2288 247.266C75.8942 243.736 68.876 245.804 69.2481 247.171C69.6202 248.538 75.9288 251.697 81.3115 253.921C86.6942 256.145 88.875 253.324 88.875 253.324Z",
    fill: "#59D9C6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1201 221.339C65.1201 221.339 62.273 218.804 61.6586 213.421C61.0442 208.038 65.4576 197.585 67.9932 199.168C70.5288 200.752 71.4547 212.469 70.5201 216.588C69.5855 220.708 65.1201 221.339 65.1201 221.339Z",
    fill: "#59D9C6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.286 301.855C126.286 301.855 129.522 293.763 113.305 272.198C97.0875 250.633 56.6827 229.059 51.8625 203.175",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3587 234.64L54.9866 230.521",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7077 246.046L83.1721 225.459",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3769 256.812L79.0615 250.165",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8086 226.09L65.7519 210.886",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.76 261.242L104.711 246.046",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.964 279.614L119.916 264.41",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M124.667 291.332L132.966 278.559",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.185 269.74L96.0576 267.94",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.01 289.385L108.883 287.585",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M292.595 308.224C292.595 308.224 302.166 300.747 301.898 292.526C301.63 284.305 294.291 288.251 292.059 277.451C289.826 266.651 294.092 257.971 289.307 254.536C284.521 251.1 280.419 251.784 277.191 248.564C273.964 245.345 284.244 236.406 277.278 229.742C270.312 223.079 261.9 227.034 259.243 218.181C256.587 209.328 249.62 202.673 247.691 205.503C245.761 208.333 252.926 211.301 253.393 216.926C253.861 222.551 257.841 234.234 253.783 242.446C249.724 250.659 259.027 250.416 263.172 255.15C267.317 259.884 264.531 264.444 261.762 271.168C258.992 277.892 273.462 276.923 273.695 280.817C273.929 284.712 269.602 283.656 267.491 291.245C265.379 298.835 277.97 305.481 277.97 305.481",
    fill: "url(#paint5_linear_575_72001)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M283.595 305.628C283.595 305.628 284.936 279.883 278.091 259.806C271.246 239.729 262.566 234.389 259.269 226.835",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M260.472 244.168L272.051 247.007L272.605 234.935",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.558 267.975L280.982 271.878L284.106 263.7",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M276.932 292.465L283.699 297.372L290.233 287.29",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M305.169 227.544C302.149 223.996 302.815 219.712 304.148 214.615C305.238 210.41 310.387 203.85 315.952 203.123C316.886 203.002 316.904 203.123 316.817 203.824C316.488 208.272 315.415 214.953 313.459 218.613C311.132 223.018 308.561 224.463 305.169 227.544Z",
    fill: "#59D9C6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M319.569 274.829C318.868 272.466 319.621 269.991 320.434 267.828C321.248 265.664 328.405 257.218 330.603 260.42C332.801 263.622 327.34 271.238 325.41 273.444C323.481 275.651 321.784 275.192 319.569 274.829Z",
    fill: "#59D9C6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M322.529 294.231C321.897 291.834 322.676 289.263 323.524 287.091C324.372 284.919 331.529 276.707 333.683 279.943C335.838 283.18 330.369 290.795 328.439 292.985C326.509 295.174 324.735 294.689 322.529 294.231Z",
    fill: "#59D9C6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M322.52 306.58C323.195 304.165 325.185 302.357 327.02 300.894C328.855 299.432 339.135 296.013 339.386 299.89C339.637 303.767 331.07 307.54 328.292 308.458C325.514 309.375 324.225 308.077 322.52 306.58Z",
    fill: "#59D9C6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M315.969 284.712C313.529 285.291 311.08 284.383 308.925 283.474C306.77 282.565 299.042 275.045 302.305 273.089C305.567 271.134 312.836 276.923 315 278.836C317.163 280.748 316.462 282.591 315.969 284.712Z",
    fill: "#59D9C6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M316.342 304.036C313.901 304.52 311.452 303.568 309.349 302.556C307.246 301.543 299.683 293.763 303.041 291.868C306.398 289.973 313.521 295.987 315.546 298.064C317.571 300.141 316.939 301.872 316.342 304.036Z",
    fill: "#59D9C6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M314.922 253.151C312.776 252.381 314.472 247.509 314.879 245.916C315.286 244.324 321.759 234.736 323.671 238.128C325.584 241.52 321.836 248.807 320.21 250.962C318.583 253.116 317.068 253.921 314.922 253.151Z",
    fill: "#59D9C6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M303.118 244.393C304.304 241.97 303.681 239.201 302.305 236.96C300.929 234.718 293.841 229.171 291.539 231.352C289.238 233.533 294.248 239.14 295.797 240.871C297.346 242.602 300.453 245.146 303.118 244.393Z",
    fill: "#59D9C6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M309.912 266.789C310.82 264.687 308.553 261.736 307.817 260.1C307.082 258.464 300.617 252.087 299.164 254.631C297.71 257.175 302.954 262.186 304.226 264.098C305.498 266.011 307.766 267.317 309.912 266.789Z",
    fill: "#59D9C6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M308.215 235.938C307.713 233.507 308.631 231.04 309.626 228.92C310.621 226.8 318.28 219.193 320.27 222.534C322.261 225.874 316.246 233.013 314.213 235.056C312.179 237.098 310.388 236.492 308.215 235.938Z",
    fill: "#59D9C6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M315.251 316.99C320.582 304.875 321.248 304.676 319.145 287.74C317.042 270.805 298.177 238.483 307.982 218.155",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M307.419 248.279C303.802 244.757 300.392 241.053 296.991 237.332",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M310.803 260.671C313.234 255.747 315.822 250.91 318.297 246.012",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M315.363 272.717C311.772 268.633 307.921 264.79 304.338 260.688",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M305.749 238.976L313.598 229.154",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M317.354 278.013C319.708 274.552 322.088 271.134 324.424 267.672",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M320.192 297.459C322.676 293.997 325.073 290.536 327.47 287.074",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M318.92 308.198C322.774 306.467 326.619 304.693 330.455 302.876",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M319.05 287.126C315.756 284.57 312.424 282.055 309.055 279.58",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M319.327 306.537C316.102 303.871 312.86 301.226 309.6 298.601",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4932 328.145C45.4932 328.145 184.725 253.263 342.684 328.145",
    stroke: "url(#paint6_linear_575_72001)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M208.385 107.533C212.945 106.563 216.277 105.092 215.827 100.912C215.377 96.7327 210.297 93.9461 209.769 91.8086C209.241 89.6711 212.746 86.4606 211.985 82.3759C211.223 78.2913 207.156 73.7221 203.071 74.449C203.071 74.449 202.396 75.799 201.73 72.9C201.063 70.0009 198.883 66.4096 194.867 67.8029C190.653 69.2654 190.653 71.7144 189.415 72.1298C185.989 73.5827 182.641 75.2147 179.385 77.0192C176.14 78.8106 175.612 84.4269 175.128 86.3913C174.643 88.3557 173.094 88.8231 170.801 88.4336C168.508 88.0442 166.11 87.6202 165.609 89.8702C165.107 92.1202 164.847 94.2836 163.255 94.1538C161.662 94.024 159.88 91.6615 158.651 93.6519C157.422 95.6423 155.016 99.4673 152.437 98.2904C149.859 97.1134 146.873 92.3452 142.728 94.2663C138.583 96.1875 137.795 101.622 139.405 102.479C141.014 103.336 141.81 104.66 141.421 106.053C141.032 107.446 136.134 106.165 134.593 109.125C133.053 112.085 136.696 114.759 136.713 116.368C136.731 117.978 135.848 119.449 132.958 120.262C130.067 121.076 128.034 123.369 129.963 124.875C131.893 126.381 131.634 124.572 132.11 123.49C132.585 122.409 134.091 122.218 135.839 123.101C137.587 123.984 138.643 122.123 138.643 122.123C138.643 122.123 138.392 124.425 140.374 125.057C142.356 125.688 142.676 127.8 140.374 128.423C138.072 129.046 136.48 132.291 138.202 134.204C139.924 136.116 142.65 137.311 147.254 136.056C151.858 134.801 161.784 127.402 168.17 131.175C174.557 134.948 185.988 134.844 191.605 132.906C197.221 130.967 198.675 125.039 203.097 124.053C207.519 123.066 206.342 120.513 205.598 117.995C204.854 115.477 203.824 108.502 208.385 107.533ZM211.595 103.396C212.233 102.732 212.637 101.879 212.746 100.964C212.976 101.096 213.176 101.273 213.336 101.484C213.496 101.696 213.611 101.937 213.676 102.193C213.741 102.45 213.753 102.717 213.712 102.979C213.671 103.241 213.578 103.491 213.438 103.716C212.53 105.612 210.159 104.911 210.159 104.911L211.595 103.396ZM146.336 99.5884C145.341 99.4154 143.256 103.05 142.71 101.89C142.165 100.731 143.411 96.1529 145.644 95.9538C147.877 95.7548 150.222 99.9692 150.222 99.9692C149.928 101.674 147.332 99.7615 146.336 99.5884ZM194.417 72.0692C194.038 71.9629 193.64 71.9388 193.251 71.9985C192.861 72.0582 192.489 72.2003 192.159 72.4154C192.179 72.0405 192.277 71.674 192.446 71.3389C192.615 71.0038 192.852 70.7073 193.142 70.4683C193.431 70.2292 193.767 70.0528 194.128 69.95C194.489 69.8472 194.867 69.8204 195.239 69.8711C197.083 70.1913 197.498 72.9 197.498 72.9C196.495 72.5402 195.465 72.2623 194.417 72.0692Z",
    fill: "#1D1D1D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6721 194.322L109.566 188.109C109.959 189.815 109.976 191.587 109.618 193.301C109.064 196.529 108.182 200.068 105.291 200.008C102.401 199.947 96.6721 194.322 96.6721 194.322Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M140.348 216.883C140.348 216.883 145.116 205.356 146.12 203.599C147.124 201.842 154.419 201.349 153.164 207.311C151.909 213.274 147.799 216.415 145.194 216.831C143.591 217.095 141.956 217.112 140.348 216.883Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8057 145.783C78.2022 147.268 76.8749 149.026 75.8855 150.975C74.6912 153.701 73.2893 157.033 73.2893 157.033C73.2893 157.033 87.2999 144.71 94.9239 144.216C102.548 143.723 104.443 143.775 104.443 143.775C104.443 143.775 94.9932 139.37 89.948 140.72C86.4897 141.778 83.2317 143.404 80.3076 145.532L79.8057 145.783Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M180.069 125.386C180.069 125.386 161.792 129.912 143.541 133.563C125.29 137.215 107.775 133.105 97.6153 135.77C87.4557 138.436 79.8057 145.783 79.8057 145.783C79.8057 145.783 89.4547 139.933 95.3826 144.917C101.31 149.902 100.687 153.104 96.5249 159.075C92.3624 165.046 88.7364 173.916 94.9932 177.248C101.25 180.58 107.368 192.219 107.316 194.815C107.264 197.412 106.399 197.412 106.399 197.412L96.646 194.322C96.646 194.322 102.167 206.559 114.534 208.263C126.9 209.968 133.061 205.191 140.841 205.667C148.621 206.143 148.188 213.032 148.188 213.032C148.188 213.032 140.642 215.187 140.322 216.909C140.002 218.631 142.269 220.119 151.269 217.713C160.269 215.308 164.743 208.194 168.975 212.608C173.207 217.021 175.716 221.114 180.337 221.21C184.959 221.305 187.944 215.887 193.716 202.448C199.488 189.009 220.335 171.294 221.235 156.003C222.135 140.712 213.594 121.5 213.594 121.5L180.069 125.386Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M174.159 131.902C174.159 131.902 160.529 135.078 149.711 141.776C138.894 148.474 118.082 150.343 112.258 152.818C109.287 153.993 106.449 155.481 103.794 157.258",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M106.442 197.412C110.852 193.046 114.471 187.948 117.138 182.345C122.206 171.709 130.344 162.835 140.504 156.868C151.607 150.464 157.093 150.291 167.331 143.585",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M148.214 213.006C148.214 213.006 156.003 187.2 162.216 178.39",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M170.039 272.899C169.045 278.135 167.185 283.168 164.535 287.792C160.035 295.771 158.832 298.056 157.664 298.895C156.496 299.735 154.151 301.137 156.453 301.76C158.755 302.383 165.107 302.512 167.417 301.699C169.728 300.886 169.485 299.146 170.42 295.996C170.606 295.144 171.041 294.367 171.669 293.763C172.298 293.159 173.092 292.755 173.951 292.604L173.752 302.123H175.482L176.227 294.058C176.227 294.058 177.447 290.916 177.205 288.865C176.962 286.814 174.686 285.058 174.686 285.058L177.533 273.288L170.039 272.899Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M175.482 302.158L176.227 294.092C176.227 294.092 177.447 290.951 177.205 288.9C177.014 287.325 175.612 285.906 174.989 285.352C173.111 287.688 170.818 293.815 167.521 296.481C166.343 297.382 164.969 297.993 163.51 298.264C162.052 298.534 160.55 298.457 159.127 298.038L158.651 297.831C158.376 298.224 158.043 298.574 157.664 298.869C156.496 299.735 154.151 301.111 156.453 301.734C158.755 302.357 165.107 302.487 167.417 301.673C169.728 300.86 169.485 299.12 170.42 295.97C170.606 295.118 171.041 294.341 171.669 293.737C172.298 293.133 173.092 292.729 173.951 292.578L173.752 302.097L175.482 302.158Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M234.562 274.258C235.335 279.531 236.985 284.638 239.443 289.367C243.597 297.528 244.705 299.864 245.838 300.756C246.972 301.647 249.248 303.136 246.929 303.663C244.61 304.191 238.275 304.053 235.982 303.144C233.688 302.236 234.017 300.505 233.212 297.312C233.061 296.454 232.659 295.661 232.057 295.032C231.455 294.404 230.679 293.968 229.829 293.781L229.63 303.3L227.899 303.257L227.492 295.174C227.492 295.174 226.402 291.981 226.731 289.982C227.06 287.983 229.405 286.287 229.405 286.287L227.06 274.405L234.562 274.258Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M227.899 303.257L227.492 295.174C227.492 295.174 226.402 291.981 226.731 289.982C226.99 288.424 228.462 287.065 229.102 286.52C230.876 288.943 232.91 295.174 236.086 297.961C237.226 298.91 238.574 299.578 240.02 299.909C241.467 300.239 242.971 300.224 244.411 299.864L244.895 299.683C245.153 300.089 245.471 300.454 245.838 300.764C246.972 301.63 249.248 303.144 246.929 303.672C244.61 304.2 238.275 304.062 235.982 303.153C233.688 302.244 234.017 300.513 233.212 297.32C233.061 296.463 232.659 295.669 232.057 295.041C231.455 294.412 230.679 293.977 229.829 293.789L229.63 303.309L227.899 303.257Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M188.342 162.744C188.342 162.744 176.391 190.229 174.73 200.873C173.068 211.517 167.686 275.192 167.686 275.192L179.212 275.729L196.338 202.5L199.506 189L226.177 278.714L236.008 278.057C236.008 278.057 225.623 210.323 221.616 194.114C218.832 183.287 215.284 172.671 210.998 162.346L188.342 162.744Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M193.465 103.604C193.465 103.604 193.509 116.325 193.465 117.874C193.422 119.423 179.135 123.62 179.135 123.62L188.385 162.744C188.385 162.744 200.501 163.774 211.041 162.294L217.964 120.565L204.984 117.969L205.503 107.749C205.503 107.749 197.308 107.567 193.465 103.604Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M209.423 118.861C208.48 122.4 205.399 131.287 198.311 130.387C192.184 129.609 188.446 123.568 187.13 121.024C183.271 122.4 179.074 123.62 179.074 123.62L188.325 162.744C188.325 162.744 200.44 163.774 210.98 162.294L217.904 120.565L209.423 118.861Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M189.727 119.042C189.727 119.042 193.188 137.882 194.054 148.465C194.919 159.049 194.919 166.318 194.729 167.712C194.538 169.105 185.08 206.126 185.08 206.126L168.637 198.952L185.227 162.234C185.227 162.234 175.708 126.519 175.768 125.273C175.829 124.027 189.727 119.042 189.727 119.042Z",
    fill: "url(#paint7_linear_575_72001)",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M186.603 120.366L185.062 134.602L188.524 137.319L185.928 141.914L194.582 164.414C194.582 164.414 194.504 153.398 193.881 146.094C193.258 138.79 189.64 119.025 189.64 119.025L186.603 120.366Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M206.965 118.16C206.965 118.16 204.577 165.574 204.56 166.033C204.542 166.491 217.54 206.013 217.54 206.013L230.348 201.937L213.378 160.797C213.378 160.797 221.478 122.184 221.339 121.413C221.201 120.643 206.965 118.16 206.965 118.16Z",
    fill: "url(#paint8_linear_575_72001)",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M210.678 119.172L212.391 135.511L208.082 137.916L212.123 141.387L204.56 166.033L206.965 118.16L210.678 119.172Z",
    fill: "url(#paint9_linear_575_72001)",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M206.983 86.3394C206.95 86.1751 206.907 86.0132 206.853 85.8548C206.55 84.9202 205.65 83.0423 203.391 84.124C200.475 85.5086 198.822 88.65 196.65 89.0394C195.743 89.2288 194.823 89.3532 193.898 89.4115C193.898 89.4115 190.566 96.7067 188.948 97.9702C187.82 98.7846 186.53 99.3482 185.166 99.6231C185.166 99.6231 185.634 104.686 187.061 105.438C187.524 105.643 188.031 105.73 188.535 105.691C189.04 105.651 189.526 105.487 189.952 105.213C189.952 105.213 194.036 110.207 196.754 111.557C199.471 112.907 202.491 113.287 204.092 112.422C205.693 111.557 210.288 106.364 210.349 103.457C210.41 100.549 209.12 93.3231 208.886 90.476C208.88 89.691 208.707 88.9164 208.379 88.2033C208.05 87.4902 207.575 86.8549 206.983 86.3394Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M197.645 83.9423C197.645 83.9423 198.069 84.2365 197.472 85.2404C196.974 85.9792 196.377 86.646 195.698 87.2221C195.698 87.2221 198.588 86.9971 199.791 84.8509C200.994 82.7048 199.41 82.4279 197.645 83.9423Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M198.424 94.1625C198.554 94.9067 198.311 95.5731 197.879 95.6509C197.446 95.7288 197.013 95.1836 196.866 94.4394C196.719 93.6952 196.979 93.0288 197.411 92.9509C197.844 92.8731 198.294 93.4615 198.424 94.1625Z",
    fill: "#1D1D1D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M205.814 93.1673C205.944 93.9115 205.693 94.5779 205.26 94.6558C204.828 94.7336 204.395 94.1798 204.248 93.4356C204.101 92.6913 204.36 92.025 204.793 91.9471C205.226 91.8692 205.676 92.4144 205.814 93.1673Z",
    fill: "#1D1D1D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M195.17 91.8692L199.376 90.9432",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M203.01 89.723C203.01 89.723 204.36 87.4384 206.221 88.0529",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M202.889 102.28C202.889 102.28 198.104 103.188 196.832 100.419",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M203.625 95.7548C203.625 95.7548 204.395 98.4375 201.963 98.6971",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M223.892 168.923C223.892 168.923 216.64 174.358 216.614 175.751C216.588 177.144 217.938 179.212 218.388 179.662C218.838 180.112 220.214 181.393 220.214 181.393C220.214 181.393 223.953 180.528 223.832 178.987C223.711 177.447 223.269 177.404 223.269 177.404L226.324 172.211L223.892 168.923Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M223.243 177.438L221.504 179.109",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M217.333 134.048L235.108 151.944L222.81 168.438L226.748 173.016C226.748 173.016 246.409 152.645 246.444 150.94C246.479 149.236 224.541 123.187 223.165 122.227C221.789 121.266 218.7 120.73 218.7 120.73",
    fill: "url(#paint10_linear_575_72001)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M217.333 134.048L235.108 151.944L222.81 168.438L226.748 173.016C226.748 173.016 246.409 152.645 246.444 150.94C246.479 149.236 224.541 123.187 223.165 122.227C221.789 121.266 218.7 120.73 218.7 120.73",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M175.993 168.101C175.993 168.101 183.73 172.809 183.894 174.159C184.058 175.509 182.916 177.715 182.509 178.226C182.103 178.737 180.865 180.173 180.865 180.173C180.865 180.173 177.066 179.688 177.032 178.131C176.997 176.573 177.464 176.521 177.464 176.521L173.942 171.632L175.993 168.101Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M177.456 176.521L179.351 178.01",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M181.783 135.623L163.912 151.996L177.014 167.512L173.553 172.454C173.553 172.454 152.732 153.796 152.533 152.1C152.334 150.404 175.033 124.468 176.46 123.542C177.888 122.616 180.986 122.244 180.986 122.244",
    fill: "url(#paint11_linear_575_72001)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M181.783 135.623L163.912 151.996L177.014 167.512L173.553 172.454C173.553 172.454 152.732 153.796 152.533 152.1C152.334 150.404 175.033 124.468 176.46 123.542C177.888 122.616 180.986 122.244 180.986 122.244",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M191.051 127.108C191.051 127.108 193.578 120.773 193.223 118.765C192.868 116.758 189.459 117.286 187.442 118.047C185.426 118.809 182.57 121.742 182.57 121.742C182.57 121.742 187.97 121.448 188.775 121.067C189.58 120.686 190.869 126.346 191.051 127.108Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M204.958 117.961L206.403 128.233C206.403 128.233 207.891 123.906 209.734 121.708C210.572 120.614 211.608 119.689 212.789 118.982C212.789 118.982 208.497 117.19 204.958 117.961Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_575_72001",
    x1: 24.7644,
    y1: 28.845,
    x2: 282.463,
    y2: 344.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_575_72001",
    x1: 218.813,
    y1: 101.984,
    x2: 237.885,
    y2: 161.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_575_72001",
    x1: 90.7876,
    y1: 207.484,
    x2: 121.634,
    y2: 303.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_575_72001",
    x1: 36.502,
    y1: 159.71,
    x2: 47.023,
    y2: 192.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_575_72001",
    x1: 1.21094,
    y1: 217.308,
    x2: 94.4789,
    y2: 323.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_575_72001",
    x1: 247.361,
    y1: 204.843,
    x2: 332.694,
    y2: 249.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_575_72001",
    x1: 45.4932,
    y1: 294.864,
    x2: 52.8547,
    y2: 360.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_575_72001",
    x1: 168.637,
    y1: 119.042,
    x2: 216.678,
    y2: 133.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_575_72001",
    x1: 204.56,
    y1: 118.16,
    x2: 252.045,
    y2: 132.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_575_72001",
    x1: 204.56,
    y1: 118.16,
    x2: 219.815,
    y2: 120.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_575_72001",
    x1: 217.333,
    y1: 120.73,
    x2: 261.778,
    y2: 145.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_575_72001",
    x1: 152.531,
    y1: 122.244,
    x2: 196.209,
    y2: 147.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatIlustration);
export default __webpack_public_path__ + "static/media/what-ilustration.7b73d7b0d73c582c4e8e9fedbbd73abb.svg";
export { ForwardRef as ReactComponent };